import type { PositionedFuseNode } from "./fuseSymbolGroups";

export type FuseCableGroup = { label: string; items: PositionedFuseNode[] };

/** Combines adjacent, aligned conductors of one destination cable, restarting at gaps or repeated wires. */
export function groupFuseCables(nodes: PositionedFuseNode[]): FuseCableGroup[] {
  const groups: FuseCableGroup[] = [];
  const active = new Map<number, FuseCableGroup>();
  for (const item of nodes) {
    const cable = item.node.cable;
    if (item.node.kind !== "wire" || !cable) continue;
    let group = active.get(item.x);
    const previous = group?.items[group.items.length - 1];
    const sameCable =
      previous?.node.cable?.consumerId === cable.consumerId && previous?.node.cable?.typeId === cable.typeId;
    const repeatedWire = group?.items.some((entry) => entry.node.cable?.wireIndex === cable.wireIndex);
    if (!previous || previous.endsConsumerBlock || previous.row !== item.row - 1 || !sameCable || repeatedWire) {
      group = { label: cable.label, items: [] };
      groups.push(group);
      active.set(item.x, group);
    }
    group!.items.push(item);
  }
  return groups;
}
